import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DEFAULT_TIMEOUT, TimeoutInterceptor } from './timeout.interceptor';
import { environment } from '../../../../environments/environment';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
	imports: [SharedModule],
	providers: [
		[{ provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true }],
		[{ provide: DEFAULT_TIMEOUT, useValue: environment.config.httpclient.timeout }],
	],
})
export class HttpClientTimeoutModule {
	constructor() {}
}
